export const getContactInfo =async () =>{
    return {location:"https://maps.google.com/?cid=1003807401387353845&entry=gps", phone:"+591 72260717", whatsapp:"https://wa.me/message/HMS7ZIWYN2R4G1", email:"plantsbolivia@gmail.com",
            facebook: "https://www.facebook.com/Smartplantss", youtube:"https://www.youtube.com/channel/UCadUNgiOaxB17sUOk6zgBMA",
            tiktok:"https://vm.tiktok.com/ZML1hew2Q/", instagram:"https://www.instagram.com/smartplantss"}
}